var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.771484,
    width: 44,
    height: 44,
    rx: 22,
    style: {
      fill: "rgb(29, 161, 242)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_1897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1042 13.6667L21.9375 22.8334",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1042 13.6667L25.2708 30.3334L21.9375 22.8334L14.4375 19.5001L31.1042 13.6667Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "rgb(255, 255, 255)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_1897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.7715 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon2);
export default __webpack_public_path__ + "static/media/sendIcon2.f5ce4491e251c2317dcc49b3d3905af1.svg";
export { ForwardRef as ReactComponent };